import zh_Hans from './zh-Hans.json'
import zh_Hant from './zh-Hant.json'
import { createI18n, lang, currentLang, setLang } from './core'

const locals = {
  'zh-Hans': zh_Hans,
  'zh-Hant': zh_Hant
}

const { t, nt } = createI18n(locals)

export { lang, currentLang, setLang, nt, t }
